export namespace ServiciosActions {
    export class LoadUnidades {
    static readonly type = '[Servicios] Load Unidades';
    constructor(public slug: string) {}
    }
    export class SelectUnidad {
      static readonly type ='[Servicios] Select Unidad';
      constructor(public slugUnidad: string) {}
    }
  }
  